import { Component, OnDestroy, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-personaall-data',
  templateUrl: './personaall-data.component.html',
  styleUrls: ['./personaall-data.component.css'],
})
export class PersonaallDataComponent implements OnInit, OnDestroy {
  profileForm!: FormGroup;
  userImage: String | null = null;
  userPic: File | null = null;
  // selectedFile: File | null = null;
  userLang: string = localStorage.getItem('userLang') || 'en';
countries = [
  { en: 'Saudi Arabia',         ar: 'المملكة العربية السعودية' },
  { en: 'Egypt',                ar: 'مصر' },
  { en: 'United Arab Emirates', ar: 'الإمارات العربية المتحدة' },
  { en: 'Kuwait',               ar: 'الكويت' },
  { en: 'Qatar',                ar: 'قطر' },
  { en: 'Bahrain',              ar: 'البحرين' },
  { en: 'Oman',                 ar: 'عُمان' },
  { en: 'Jordan',               ar: 'الأردن' },
  { en: 'Lebanon',              ar: 'لبنان' },
  { en: 'Syria',                ar: 'سوريا' },
  { en: 'Iraq',                 ar: 'العراق' },
  { en: 'Yemen',                ar: 'اليمن' },
  { en: 'Libya',                ar: 'ليبيا' },
  { en: 'Tunisia',              ar: 'تونس' },
  { en: 'Algeria',              ar: 'الجزائر' },
  { en: 'Morocco',              ar: 'المغرب' },
  { en: 'Sudan',                ar: 'السودان' },
  { en: 'Somalia',              ar: 'الصومال' },
  { en: 'Mauritania',           ar: 'موريتانيا' },
  { en: 'Comoros',              ar: 'جزر القمر' },
  { en: 'Djibouti',             ar: 'جيبوتي' },
  { en: 'Palestine',            ar: 'فلسطين' },
  { en: 'Germany',              ar: 'ألمانيا' },
  { en: 'France',               ar: 'فرنسا' },
  { en: 'Italy',                ar: 'إيطاليا' },
  { en: 'Spain',                ar: 'إسبانيا' },
  { en: 'Netherlands',          ar: 'هولندا' },
  { en: 'Belgium',              ar: 'بلجيكا' },
  { en: 'Sweden',               ar: 'السويد' },
  { en: 'Poland',               ar: 'بولندا' },
  { en: 'Portugal',             ar: 'البرتغال' },
  { en: 'Austria',              ar: 'النمسا' },
  { en: 'Greece',               ar: 'اليونان' },
  { en: 'Denmark',              ar: 'الدنمارك' },
];

  showCountryDropdown = false;
  countrySearch = '';

  @ViewChild('countryTrigger') countryTrigger!: ElementRef;

  private subscriptions = new Subject<void>();

  constructor(private fb: FormBuilder, public userService: UserService) {}

  ngOnInit(): void {
    this.initializeForm();
    this.userService.getUserData().subscribe({
      next: (response: any) => {
        if (response.pictureUrl) {
          this.userImage = response.pictureUrl;
        } else {
          this.userImage = this.userService.getUserImage();
        }
        this.userService.setUserInfo({
          ...response,
          picture: this.userImage,
        });
      },
    });

    this.userService
      .getUserInfo$()
      .pipe(takeUntil(this.subscriptions))
      .subscribe((userInfo) => {
        if (userInfo) {
          this.updateFormWithUserInfo(userInfo);
        }
      });
  }

  ngOnDestroy() {
    this.subscriptions.next();
    this.subscriptions.complete();
  }

  private initializeForm(): void {
    const userInfo = this.userService.getUserInfo();

    this.profileForm = this.fb.group({
      fullName: [userInfo?.name || ''],
      email: [userInfo?.email || ''],
      phone: [userInfo?.phoneNumber || ''],
      country: [userInfo?.country || ''],
      // title: [userInfo?.title || userInfo?.jobTitle || ''],
    });

    this.userImage = this.userService.getUserImage();
  }
  private updateFormWithUserInfo(userInfo: any): void {
    if (this.profileForm) {
      this.profileForm.patchValue({
        fullName: userInfo.name || '',
        email: userInfo.email || '',
        phone: userInfo.phoneNumber || '',
        country: userInfo.country || '',
        // title: userInfo.title || userInfo.jobTitle || '',
      });
    }

    this.userImage = this.userService.getUserImage();
  }
get displayedCountries(): string[] {
  const lang = localStorage.getItem('userLang') || 'en';
  return this.countries.map(c => lang === 'ar' ? c.ar : c.en);
}

get filteredCountries(): string[] {
  const q = this.countrySearch.toLowerCase().trim();
  const all = this.displayedCountries;
  if (!q) return all;
  return all.filter(c => c.toLowerCase().includes(q));
}

toggleCountryDropdown(): void {
  this.showCountryDropdown = !this.showCountryDropdown;
  if (this.showCountryDropdown) this.countrySearch = '';
}

selectCountry(country: string): void {
  this.profileForm.get('country')?.setValue(country);
  this.showCountryDropdown = false;
  this.countrySearch = '';
}

@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent): void {
  const trigger = this.countryTrigger?.nativeElement;
  if (trigger && !trigger.contains(event.target)) {
    this.showCountryDropdown = false;
  }
}

  onImageChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      // Store the actual File object for uploading
      this.userPic = file;
    }
    // Create preview for display
    const reader = new FileReader();
    reader.onload = () => {
      this.userImage = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  onSave() {
    if (this.profileForm.valid) {
      const currentUserInfo = this.userService.getUserInfo();
      const formValue = this.profileForm.value;

      const newData = {
        ...currentUserInfo,
        name: formValue.fullName,
        email: formValue.email,
        phoneNumber: formValue.phone,
        country: formValue.country,
        title: formValue.title,
        picture: this.userPic,
      };

      this.userService.updateUserDetails(newData).subscribe({
        next: (response) => {
          let responseData = JSON.parse(response);

          if (responseData.pictureUrl) {
            this.userImage =
              responseData.pictureUrl + '?t=' + new Date().getTime();
          } else {
            this.userImage = this.userService.getUserImage();
          }

          this.userService.setUserInfo({
            ...responseData,
            picture: this.userImage,
          });

          // Reload image from service after update
          this.userImage = this.userService.getUserImage();
          this.userService
            .getUserInfo$()
            .pipe(takeUntil(this.subscriptions))
            .subscribe((userInfo) => {
              if (userInfo) {
                this.updateFormWithUserInfo(userInfo);
              }
            });
        },
        error: (error) => console.error(error),
      });
    }
  }

  onCancel() {
    const userInfo = this.userService.getUserInfo();
    this.profileForm.reset({
      fullName: userInfo?.name || '',
      email: userInfo?.email || '',
      phone: userInfo?.phoneNumber || '',
      country: userInfo?.country || '',
      title: userInfo?.title || userInfo?.jobTitle || '',
    });
    this.userImage = this.userService.getUserImage();
  }
}
